import React from 'react';
import PropTypes from 'prop-types';

// Vendor hooks.
import { useTranslation } from 'react-i18next';

// Utils.
import { ucFirst } from '@exonet/jsonapi-data-collections/lib/utilities';

// HOC.
import boost from 'app/client/utilities/hoc/boost';

// Components.
import Switch from './components/Switch';

// Store.
import store from './store';

// Config.
import modes from './config';

// Styled.
import * as S from './styled';

const ToggleTheme = ({
  theme,
  autoSwitchTheme,
  settings,
  actions: { setAutoSwitchTheme, setTheme },
  disabled = false,
}) => {
  const { t } = useTranslation();

  const switchTheme = (type) => {
    if (type === 'auto') {
      setAutoSwitchTheme(settings, true);
      return;
    }

    setAutoSwitchTheme(settings, false);
    setTheme(settings, type);
  };

  const activeTheme = autoSwitchTheme ? 'auto' : theme;

  return (
    <S.Themes>
      {modes.map(({ name, icon }) => (
        <Switch
          key={name}
          name={t(`core:menu.theme.${name}.title`, ucFirst(name))}
          onClick={() => switchTheme(name)}
          isActive={activeTheme === name}
          icon={icon}
          disabled={disabled}
        />
      ))}
    </S.Themes>
  );
};

ToggleTheme.propTypes = {
  theme: PropTypes.string.isRequired,
  autoSwitchTheme: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    setTheme: PropTypes.func.isRequired,
    setAutoSwitchTheme: PropTypes.func.isRequired,
  }).isRequired,
  settings: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]).isRequired,
  disabled: PropTypes.bool,
};

export default boost({ store })(ToggleTheme);
